<template>
  <form class="composer" @submit.prevent="submit">
    <textarea
      ref="input"
      v-model="text"
      :placeholder="$t('aiAssistant.placeholder')"
      :disabled="disabled"
      rows="2"
      dir="auto"
      @keydown.enter.exact.prevent="submit"
    />
    <button type="submit" :disabled="disabled || !text.trim()">
      {{ $t('aiAssistant.send') }}
    </button>
  </form>
</template>

<script>
export default {
  name: "Composer",
  props: {
    onSend: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { text: "" };
  },
  methods: {
    submit() {
      const t = this.text.trim();
      if (!t || this.disabled) return;
      this.onSend(t);
      this.text = "";
    },
  },
};
</script>

<style scoped>
.composer {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: white;
}
textarea {
  flex: 1;
  resize: none;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  outline: none;
  transition: border-color 0.15s ease;
}
textarea:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}
textarea:disabled {
  background: #f9fafb;
  cursor: not-allowed;
}
button {
  background: #6366f1;
  color: white;
  border: none;
  padding: 0 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  align-self: stretch;
}
button:hover:not(:disabled) {
  background: #4f46e5;
}
button:disabled {
  background: #d1d5db;
  cursor: not-allowed;
}
</style>
